import { Link } from "react-router-dom";
import SharedNavbar from '@/components/feature/SharedNavbar';
import SharedFooter from '@/components/feature/SharedFooter';
import { Seo } from '@/components/Seo';

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | Rx.K Seoul" noindex />
      <SharedNavbar />
      <main className="relative flex flex-col items-center justify-center min-h-screen text-center px-6 bg-[#1A1A1A] pt-24">
        {/* Background number */}
        <h1 className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[10rem] md:text-[16rem] font-serif font-bold text-white/[0.03] select-none pointer-events-none z-0">
          404
        </h1>

        <div className="relative z-10 flex flex-col items-center gap-6">
          {/* Brand mark */}
          <div className="flex items-center gap-0.5">
            <span className="font-sans text-lg font-bold text-[#8A8A8A]">Rx</span>
            <span className="font-sans text-lg font-bold text-[#7B1113]">+.</span>
            <span className="font-sans text-xs font-bold tracking-[0.15em] text-[#8A8A8A] uppercase">K SEOUL</span>
          </div>

          <h2 className="font-serif text-2xl md:text-3xl font-semibold text-white">
            Page Not Found
          </h2>
          <p className="text-sm text-white/40 font-light max-w-md leading-[1.8]">
            This page is coming soon. We&apos;re building the full Rx.K Seoul experience — check back shortly or return to our homepage.
          </p>

          <Link
            to="/"
            className="mt-4 px-8 py-3 bg-[#7B1113] text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-[#5C0D0F] transition-colors cursor-pointer text-center"
          >
            Back to Home
          </Link>
        </div>
      </main>
      <SharedFooter />
    </>
  );
}